// Common blurry background component
export function BlurryBackground({
  children,
  className = "",
  position = "relative",
}: {
  children: React.ReactNode;
  className?: string;
  position?: "fixed" | "relative" | "absolute";
}) {
  const positionClass = position === "fixed" ? "fixed" : position === "absolute" ? "absolute" : "relative";

  return <div className={`backdrop-blur-[10px] backdrop-filter ${positionClass} ${className}`}>{children}</div>;
}
